import { css } from 'styled-components';
import { WithSiteLayout } from 'styles/commonCss';
import {
  mqSmallMax,
  mqTabletMax,
  mqLargeMin,
} from 'styled/tools/media-queries';

export const Pds08Styles = css`
  .site-content section {
    ${WithSiteLayout}
  }

  .site-header {
    background: transparent;
    border-bottom: none !important;
  }

  .site-content {
    overflow: visible;
  }

  .site-content > .container {
    max-width: 100%;
    padding: 0;

    background-image: url('https://res.cloudinary.com/dljz0lko8/image/upload/f_auto,q_auto/v1675899355/PDS%20PDP/backgroundtest_playful.jpg');
    background-size: contain;
    background-repeat: no-repeat;

    @media ${mqTabletMax} {
      background-size: 810px !important;
      .pds08-hero {
        padding-top: 24px !important;
      }
    }
    @media ${mqSmallMax} {
      background-size: 810px !important;
      .pds08-hero {
        padding-top: 16px !important;
      }
    }
  }

  .site-popup {
    top: 0;
    height: unset;
  }

  .site-popup-card {
    overflow-x: hidden;
    height: 100%;
    transition-timing-function: ease-out;
  }

  &.with-scrolled .site-header {
    opacity: 0;
  }

  .site-accordion {
    .icon {
      align-items: center !important;
      transform: translateY(2px);
    }
  }

  [data-vimeo-initialized] {
    > div {
      @media ${mqLargeMin} {
        padding: 56% 0 0 !important;
      }
    }
  }

  div[data-type='button'] {
    &.active {
      a {
        i:nth-of-type(1) {
          opacity: 0;
        }

        i:nth-of-type(2) {
          opacity: 1;
        }
      }
    }

    a {
      cursor: pointer;
      display: flex;

      i {
        height: 25px;
        position: absolute;
      }

      i:nth-of-type(1) {
        opacity: 1;
      }

      i:nth-of-type(2) {
        opacity: 0;
      }

      i + span {
        margin-left: 35px;
        font-weight: 500;
        text-decoration: none;
        font-size: 12px;
      }

      span {
        font-size: 13px;
        line-height: 25px;
        text-decoration: underline;
      }
    }
  }
`;
